import Relatorio from './Relatorio.vue';
import AplicacoesFinanceiras from './componentes/AplicacoesFinanceiras.vue';
import Protocolos from './componentes/Protocolos.vue';
import Rubricas from './componentes/Rubricas.vue';
import Subrubricas from './componentes/Subrubricas.vue';
import Impostos from './componentes/Impostos.vue';
import VerificacaoDePagamentos from './componentes/VerificacaoDePagamentos.vue';
import VerificacaoDePagamentosFornecedor from './componentes/VerificacaoDePagamentosFornecedor.vue';
import LancamentosCambio from './componentes/LancamentosCambio.vue';
import PedidosCompra from './componentes/PedidosCompra.vue';
import MensalidadesAgrupadasPorAluno from './componentes/MensalidadesAgrupadasPorAluno.vue';
import ContasPagarReceber from './componentes/ContasPagarReceber.vue';
import Saldos from './componentes/Saldos.vue';
import Lancamentos from './componentes/Lancamentos.vue';
import LancamentosModelo3 from './componentes/LancamentosModelo3.vue';
import LancamentosProjetos from './componentes/LancamentosProjetos.vue';
import LancamentosResumo from './componentes/LancamentosResumo.vue';
import Provisoes from './componentes/Provisoes.vue';
import ControleItem from './componentes/ControleItem.vue';
import RelatTaxasProjeto from './componentes/RelatTaxasProjeto.vue';

export default {
  path: '/relatorio',
  component: Relatorio,
  meta: { auth: true },
  children: [
    {
      path: 'aplicacoes-financeiras',
      component: AplicacoesFinanceiras,
      name: 'relatorio.aplicacoes-financeiras'
    },
    {
      path: 'protocolos',
      component: Protocolos,
      name: 'relatorio.protocolos'
    },
    {
      path: 'rubricas',
      component: Rubricas,
      name: 'relatorio.rubricas'
    },
    {
      path: 'subrubricas',
      component: Subrubricas,
      name: 'relatorio.subrubricas'
    },
    {
      path: 'impostos',
      component: Impostos,
      name: 'relatorio.impostos'
    },
    {
      path: 'verificacao-de-pagamentos',
      component: VerificacaoDePagamentos,
      name: 'relatorio.verificacao-de-pagamentos'
    },
    {
        path: 'verificacao-de-pagamentos-fornecedor',
        component: VerificacaoDePagamentosFornecedor,
        name: 'relatorio.verificacao-de-pagamentos-fornecedor'
    },
    {
      path: 'lancamentos-cambio',
      component: LancamentosCambio,
      name: 'relatorio.lancamentos-cambio'
    },
    {
      path: 'pedidos-compra',
      component: PedidosCompra,
      name: 'relatorio.pedidos-compra'
    },
    {
      path: 'mensalidades-agrupadas-por-aluno',
      component: MensalidadesAgrupadasPorAluno,
      name: 'relatorio.mensalidades-agrupadas-por-aluno'
    },
    {
      path: 'contas-pagar-receber',
      component: ContasPagarReceber,
      name: 'relatorio.contas-pagar-receber'
    },
    {
      path: 'saldos',
      component: Saldos,
      name: 'relatorio.saldos'
    },
    {
      path: 'provisoes',
      component: Provisoes,
      name: 'relatorio.provisoes'
    },
    {
      path: 'taxasProjeto',
      component: RelatTaxasProjeto,
      name: 'relatorio.taxasProjeto'
    },
    {
      path: 'lancamentos',
      component: Lancamentos,
      name: 'relatorio.lancamentos'
    },
    {
      path: 'lancamentos-modelo3',
      component: LancamentosModelo3,
      name: 'relatorio.lancamentos-modelo3'
    },
    {
      path: 'lancamentos-resumo',
      component: LancamentosResumo,
      name: 'relatorio.lancamentos-resumo'
    },
    {
      path: 'lancamentos-projetos',
      component: LancamentosProjetos,
      name: 'relatorio.lancamentos-projetos'
    },
    {
      path: 'controle-item',
      component: ControleItem,
      name: 'relatorio.controle-item'
    },
  ]
}



// WEBPACK FOOTER //
// ./FrontEnd/modulos/relatorio/rotas.js